import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Shield, ArrowLeft } from 'lucide-react';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-[#0A0F1C]">
      <Header />
      
      <div className="pt-40 pb-24 px-6">
        <div className="max-w-4xl mx-auto">
          <Link to="/" className="inline-flex items-center gap-2 text-[#2563EB] hover:text-[#3B82F6] mb-8 transition-colors">
            <ArrowLeft className="w-4 h-4" />
            Back to Home
          </Link>

          <div className="flex items-center gap-4 mb-8">
            <div className="w-14 h-14 bg-gradient-to-br from-[#2563EB] to-[#3B82F6] rounded-xl flex items-center justify-center">
              <Shield className="w-7 h-7 text-white" />
            </div>
            <div>
              <h1 className="text-4xl md:text-5xl font-bold text-[#F8FAFC]">Privacy Policy</h1>
              <p className="text-[#94A3B8]">Last updated: January 2025</p>
            </div>
          </div>

          <div className="prose prose-invert prose-lg max-w-none">
            <div className="text-[#94A3B8] leading-relaxed space-y-6">
              <p className="text-lg">
                At PriceStrike, we take your privacy seriously. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our website and services.
              </p>

              <div className="bg-gradient-to-br from-[#111827] to-[#0A0F1C] border border-[#2563EB]/30 rounded-xl p-8 mt-8">
                <h2 className="text-2xl font-bold text-[#F8FAFC] mb-4">Information We Collect</h2>
                <p>We collect information that you provide directly to us, including:</p>
                <ul className="list-disc pl-6 space-y-2 mt-4">
                  <li>Name, email address, and contact information</li>
                  <li>Company information and billing details</li>
                  <li>Pricing data you input into our platform</li>
                  <li>Usage data and analytics</li>
                  <li>Communications with our support team</li>
                </ul>
              </div>

              <div className="bg-gradient-to-br from-[#111827] to-[#0A0F1C] border border-[#2563EB]/30 rounded-xl p-8">
                <h2 className="text-2xl font-bold text-[#F8FAFC] mb-4">How We Use Your Information</h2>
                <p>We use the information we collect to:</p>
                <ul className="list-disc pl-6 space-y-2 mt-4">
                  <li>Provide, maintain, and improve our services</li>
                  <li>Process transactions and send related information</li>
                  <li>Send technical notices and support messages</li>
                  <li>Respond to your comments and questions</li>
                  <li>Analyze usage patterns and optimize our platform</li>
                  <li>Protect against fraudulent or illegal activity</li>
                </ul>
              </div>

              <div className="bg-gradient-to-br from-[#111827] to-[#0A0F1C] border border-[#2563EB]/30 rounded-xl p-8">
                <h2 className="text-2xl font-bold text-[#F8FAFC] mb-4">Data Security</h2>
                <p>
                  We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. This includes encryption, secure servers, and regular security assessments.
                </p>
              </div>

              <div className="bg-gradient-to-br from-[#111827] to-[#0A0F1C] border border-[#2563EB]/30 rounded-xl p-8">
                <h2 className="text-2xl font-bold text-[#F8FAFC] mb-4">GDPR Compliance</h2>
                <p>
                  For users in the European Union, we comply with the General Data Protection Regulation (GDPR). You have the right to:
                </p>
                <ul className="list-disc pl-6 space-y-2 mt-4">
                  <li>Access your personal data</li>
                  <li>Rectify inaccurate data</li>
                  <li>Request deletion of your data</li>
                  <li>Object to processing of your data</li>
                  <li>Data portability</li>
                  <li>Withdraw consent at any time</li>
                </ul>
              </div>

              <div className="bg-gradient-to-br from-[#111827] to-[#0A0F1C] border border-[#2563EB]/30 rounded-xl p-8">
                <h2 className="text-2xl font-bold text-[#F8FAFC] mb-4">Cookies and Tracking</h2>
                <p>
                  We use cookies and similar tracking technologies to enhance your experience. You can control cookies through your browser settings. For more information, see our <Link to="/cookie-policy" className="text-[#2563EB] hover:text-[#3B82F6]">Cookie Policy</Link>.
                </p>
              </div>

              <div className="bg-gradient-to-br from-[#111827] to-[#0A0F1C] border border-[#2563EB]/30 rounded-xl p-8">
                <h2 className="text-2xl font-bold text-[#F8FAFC] mb-4">Contact Us</h2>
                <p>
                  If you have questions about this Privacy Policy, please contact us at:
                </p>
                <p className="mt-4">
                  Email: <a href="mailto:privacy@axiosera.com" className="text-[#2563EB] hover:text-[#3B82F6]">privacy@axiosera.com</a><br />
                  Address: Drielandendreef 42, 3845 CA, Harderwijk, The Netherlands
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
